export default 
// 20191202175830
// https://localhost:44387/api/example/getlov

{
  "userStatus": [
    {
      "key": "[ACTIVE]",
      "text": "Ativo"
    },
    {
      "key": "[SUSPENDED_PASSWORD]",
      "text": "Suspenso por Senha"
    },
    {
      "key": "[SUSPENDED_BY_ADMIN]",
      "text": "Suspenso Administrativamente"
    }
  ],
  "areaObservacaoStatus": [
    {
      "key": "[PENDING]",
      "text": "Pendente"
    },
    {
      "key": "[DONE]",
      "text": "Atendido"
    }
  ],
  "queueItemStatus": [
    {
      "key": "[WAITING]",
      "text": "Aguardando"
    },
    {
      "key": "[EXECUTING]",
      "text": "Em execução"
    },
    {
      "key": "[ERROR]",
      "text": "Falha de execução"
    },
    {
      "key": "[COMPLETED]",
      "text": "Concluído"
    },
    {
      "key": "[CANCELED]",
      "text": "Cancelado"
    }
  ],
  "queueItemQueueType": [
    {
      "key": "[EMAIL]",
      "text": "E-mail"
    },
    {
      "key": "[PROCESS_SHAPE]",
      "text": "Process Shape"
    },
    {
      "key": "[IMPORT_SHAPE]",
      "text": "Import Shape"
    },
    {
      "key": "[PREFEITURA_TRUEDB_CONSOLIDADE]",
      "text": "Importa os dados da base TRUEDB para a base PREFEITURA"
    },
    {
      "key": "[PREFEITURA_SCRIPT_EXECUTE]",
      "text": "Executa scripts de UPDATE que forem especificados na tela Atualizar Unidades da app"
    },
    {
      "key": "[EXECUTE_EXPORT_PDF]",
      "text": "Exportar PDF"
    }
  ],
  "mapServiceType": [
    {
      "key": "[GEOSERVER]",
      "text": "Geoserver - WMS"
    },
    {
      "key": "[AMAZON_S3]",
      "text": "Esri ArcGIS Server - Tile Cache (Amazon S3)"
    },
    {
      "key": "[TMS]",
      "text": "TMS - Tile Cache"
    },
    {
      "key": "[INVERTED_Y_TMS]",
      "text": "TMS com Y invertido - Tile Cache"
    }
  ],
  "mapServiceUsageType": [
    {
      "key": "[OVERLAY]",
      "text": "Camada de Referência"
    },
    {
      "key": "[BASEMAP]",
      "text": "Mapa de Fundo"
    }
  ],
  "mapServiceImageFormat": [
    {
      "key": "[PNG]",
      "text": "Formato PNG"
    },
    {
      "key": "[JPG]",
      "text": "Formato JPG"
    },
    {
      "key": "[JPEG]",
      "text": "Formato JPEG"
    }
  ],
  "avaliacaoTipo": [
    {
      "key": "[TERRENO]",
      "text": "TERRENO"
    },
    {
      "key": "[CONSTRUCAO]",
      "text": "CONSTRUÇÃO"
    }
  ],
  "fieldDefinitionGroupKey": [
    {
      "key": "[VIEW]",
      "text": "VIEW"
    },
    {
      "key": "[VIEW_ITEM]",
      "text": "VIEW_ITEM"
    },
    {
      "key": "[LIST]",
      "text": "LIST"
    },
    {
      "key": "[INNER_LIST]",
      "text": "INNER_LIST"
    },
    {
      "key": "[RELATORIO_UNIDADE]",
      "text": "RELATORIO_UNIDADE"
    },
    {
      "key": "[TABLE]",
      "text": "TABLE"
    },
    {
      "key": "[TABLE_COMPLETE]",
      "text": "TABLE_COMPLETE"
    }
  ],
  "fieldDefinitionOwnerType": [
    {
      "key": "[LOTE]",
      "text": "LOTE"
    },
    {
      "key": "[UNIDADE]",
      "text": "UNIDADE"
    },
    {
      "key": "[TERRENO]",
      "text": "TERRENO"
    },
    {
      "key": "[CONSTRUCAO]",
      "text": "CONSTRUCAO"
    },
    {
      "key": "[IPTU]",
      "text": "IPTU"
    },
    {
      "key": "[ITBI]",
      "text": "ITBI"
    }
  ],
  "fieldDefinitionValueType": [
    {
      "key": "[TEXT]",
      "text": "Texto"
    },
    {
      "key": "[INT]",
      "text": "Inteiro"
    },
    {
      "key": "[NUMBER]",
      "text": "Real"
    },
    {
      "key": "[BOOLEAN]",
      "text": "Lógico"
    },
    {
      "key": "[DATE]",
      "text": "Data"
    },
    {
      "key": "[DATETIME]",
      "text": "Data Hora"
    },
    {
      "key": "[LOV]",
      "text": "Lista de Valores"
    }
  ],
  "shapeStatus": [
    {
      "key": "[WAITING]",
      "text": "Aguardando"
    },
    {
      "key": "[EXECUTING]",
      "text": "Em execução"
    },
    {
      "key": "[ERROR]",
      "text": "Falha de execução"
    },
    {
      "key": "[PROCESSED_SUCCESS]",
      "text": "Processado com sucesso"
    },
    {
      "key": "[PROCESSED_ERROR]",
      "text": "Processado com erro"
    },
    {
      "key": "[IMPORTING]",
      "text": "Importando"
    },
    {
      "key": "[COMPLETED]",
      "text": "Concluído"
    },
    {
      "key": "[CANCELED]",
      "text": "Cancelado"
    }
  ],
  "requestStatus": [
    {
      "key": "[ABERTO]",
      "text": "Aberto"
    },
    {
      "key": "[EM_ATENDIMENTO]",
      "text": "Em Atendimento"
    },
    {
      "key": "[ATENDIDO]",
      "text": "Atendido"
    },
    {
      "key": "[CONCLUIDO]",
      "text": "Concluído"
    }
  ],
  "requestType": [
    {
      "key": "[PENDENCIA]",
      "text": "Pendência"
    },
    {
      "key": "[AREA_OBSERVACAO]",
      "text": "Área de Observação"
    }
  ],
  "requestPriority": [
    {
      "key": "[ALTA]",
      "text": "Alta"
    },
    {
      "key": "[MEDIA]",
      "text": "Média"
    },
    {
      "key": "[BAIXA]",
      "text": "Baixa"
    }
  ],
  "requestStatusConcludeFromOpen": [
    {
      "key": "[CONCLUIDO]",
      "text": "Concluído"
    }
  ],
  "requestStatusConcludeFromSolve": [
    {
      "key": "[EM_ATENDIMENTO]",
      "text": "Em Atendimento"
    },
    {
      "key": "[CONCLUIDO]",
      "text": "Concluído"
    }
  ]
};